import {Component, forwardRef, SimpleChanges, Input, ChangeDetectorRef, Injector} from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { ReceptionMarchandiseModel } from '../reception-marchandise.model';
import { AbstractWorkflowFormComponent } from '../../../@core/abstract-workflow-form-component';
import { WorkflowComponentsService } from '../../../workflow-components.service';
import { ReceptionMarchandiseService } from '../reception-marchandise.service';
import { TYPE_DEFAULT_VALUE, Model_WorkflowComponent } from 'src/app/app.models';
import { Model_SoudotecDocument } from '../../soudotec.models';

enum Command_View {
    IDLE = 0,
    COMMAND_LOADING = 1,
    COMMAND_LOADED = 2,
    COMMAND_LOADING_ERROR = 3
}

@Component({
    selector: 'abw-reception-marchandise-form',
    providers: [
    {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ReceptionMarchandiseFormComponent),
        multi: true
    },
    {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => ReceptionMarchandiseFormComponent),
        multi: true
    }
    ],
    templateUrl: './reception-marchandise-form.component.html',
    styleUrls: ['./reception-marchandise-form.component.scss']
})
export class ReceptionMarchandiseFormComponent extends AbstractWorkflowFormComponent<ReceptionMarchandiseModel, Model_SoudotecDocument> {
  @Input() doDomaine: number;
  @Input() doType: number;
  Command_View = Command_View;
  viewMode = Command_View.IDLE;
  doPiece: string = null;
  errorText: string = null;
  startupInfos: { DOCUMENT: any; DEPOTS: any[]; EMPLACEMENTS: any[] };
  document: any;
  emplacements: any[] = [];

  constructor(
    private _receptionMarchandiseService: ReceptionMarchandiseService,
    _workflowComponentsService: WorkflowComponentsService,
    _cdf: ChangeDetectorRef,
    _injector: Injector
  ) {
    super(_workflowComponentsService, _cdf, _injector);
  }

  ngOnInit() {
    super.ngOnInit();

    let doPiece = '';
    const typeDefaultNumPiece = this.model.additional['TYPE_DEFAULT_NUM_PIECE'];
    if (typeDefaultNumPiece == TYPE_DEFAULT_VALUE.CONSTANT) {
        doPiece = this.model.additional['DEFAULT_NUM_PIECE'];
    } else if (typeDefaultNumPiece == TYPE_DEFAULT_VALUE.WORKFLOW_FIELD) {
        const componentId = this.model.additional['DEFAULT_NUM_PIECE_WORKFLOW_COMPONENT_ID'];
        const componentProperty = this.model.additional['DEFAULT_NUM_PIECE_WORKFLOW_COMPONENT_PROPERTY'];
        const workflowValues = this._workflowComponentsService.context;
        const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
        let formGroupId = workflowComponent.FORM_ID || '_FORM_';
        if (!!workflowValues.formModels && !!workflowValues.formModels[formGroupId]) {
            const targetComponent: any = workflowValues.formModels[formGroupId].find(component => component.id == componentId);
            if (!!targetComponent && !!componentProperty && !!targetComponent.additional && !!targetComponent.additional.NUM_DATASOURCE && !!targetComponent.datas) {
                const selectedData = targetComponent.datas.find(data => data[targetComponent.valueField] == targetComponent.value);
                if (!!selectedData && !!selectedData[componentProperty]) {
                    doPiece = selectedData[componentProperty];
                }
            } else {
                doPiece = targetComponent.value;
            }
        }
    }

    this.doPiece = doPiece;
    if (!!this.doPiece) {
      this.doGetStartupInfosAction();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  onQteInputChanged(inputValue, index) {
    this.document.LIGNES[index].DL_Qte = inputValue;
    this._evaluateSoudotecDocument();
  }

  private _evaluateSoudotecDocument() {
    const document: Model_SoudotecDocument = {
      cbMarq: this.document.cbMarq,
      Do_Domaine: this.doDomaine,
      DO_Type: this.doType,
      DO_Piece: this.doPiece,
      DO_Ref: this.document.DO_Ref,
      DO_Tiers: this.document.DO_Tiers,
      DO_Date: this.document.DO_Date,
      DO_TotalHTNet: this.document.DO_TotalHTNet,
      DO_TotalTTC: this.document.DO_TotalTTC,
      LIGNES: this.document.LIGNES.map(ligne => ({ 
        cbMarq: ligne.cbMarq, 
        AR_Ref: ligne.AR_Ref, 
        DL_Design: ligne.DL_Design, 
        DL_Qte: ligne.DL_Qte,
        DE_No: ligne.DE_No,
        DP_No: ligne.DP_No,
        DL_No: ligne.DL_No,
        DEPOT: !!ligne.DEPOT ? { DE_No: ligne.DEPOT.DE_No, DE_Intitule: ligne.DEPOT.DE_Intitule } : null,
        EMPLACEMENT: !!ligne.EMPLACEMENT ? { DP_No: ligne.EMPLACEMENT.DP_No, DP_Intitule: ligne.EMPLACEMENT.DP_Intitule } : null,
      }))
    };
    this.onValueChanged(document);
  }

  private async doGetStartupInfosAction() {
    try {
        this.viewMode = Command_View.COMMAND_LOADING;
        this.startupInfos = await this._receptionMarchandiseService.doGetStartupInfosAction(this.doDomaine, this.doType, this.doPiece);
        const document = this.startupInfos.DOCUMENT;
        document.LIGNES = document.LIGNES.filter(l => !!l.AR_Ref);
        document.LIGNES.forEach((ligne, index, lignes) => { lignes[index].EMPLACEMENTS = []; });
        this.document = document;
        this._evaluateSoudotecDocument();
        this.viewMode = Command_View.COMMAND_LOADED;
    } catch(err) {
        this.errorText = 'Une erreur est survenue lors du chargement de la commande. Veuillez réessayer plus tard: ' + err;
        this.viewMode = Command_View.COMMAND_LOADING_ERROR;
    }
    try { this._cdf.detectChanges(); } catch(ex) {}
  }

  onDepotChanged(depotNo, rowIndex) {
    this.document.LIGNES[rowIndex].DE_No = depotNo;
    this.document.LIGNES[rowIndex].DEPOT = this.startupInfos.DEPOTS.find(d => d.DE_No == depotNo);
    this.document.LIGNES[rowIndex].EMPLACEMENTS = this.startupInfos.EMPLACEMENTS.filter(e => e.DE_No == depotNo && !!e.DP_Intitule);
    if (this.document.LIGNES[rowIndex].EMPLACEMENTS.length > 0) {
      this.onEmplacementChanged(this.document.LIGNES[rowIndex].EMPLACEMENTS[0].DP_No, rowIndex);
    } else {
      this._evaluateSoudotecDocument();
    }
  }

  onEmplacementChanged(emplacementNo, rowIndex) {
    this.document.LIGNES[rowIndex].DP_No = emplacementNo;
    this.document.LIGNES[rowIndex].EMPLACEMENT = this.document.LIGNES[rowIndex].EMPLACEMENTS.find(e => e.DP_No == emplacementNo);
    this._evaluateSoudotecDocument();
  }
}